import { Button, Flex, Title } from "@qws-org/ui-kit";
import type { FC } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";

import type { CardGalleryProps } from "../CardGallery";
import { RowCard } from "./RowCard";

export const Row: FC<CardGalleryProps> = (props) => {
  const { data, getUrl, isControlInactive, onCallAction, ...rest } = props;
  const controlAction = data?.action;
  const isInactive = controlAction ? isControlInactive(controlAction) : true;
  const action = data.action?.action?.[0];
  const isUseSwiper = (data?.cards?.length ?? 0) > 3;
  let href;
  if (isExternalLink(action?.item)) {
    href = action.item.href ?? undefined;
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }
  const handlePressButton = (): void => {
    if (controlAction) {
      onCallAction(controlAction);
    }
  };
  return (
    <Flex
      as="section"
      width="100%"
      maxWidth="inherit"
      flexDirection="column"
      p={{ py: 32, px: 15 }}
      {...rest}
      d={{ p: { py: 64 }, ...rest.d }}
    >
      <Flex
        flexDirection="column"
        align="flex-start"
        justify="center"
        d={{
          flexDirection: action ? "row" : "column",
          justify: action ? "space-between" : "center",
          align: "center",
          m: { mb: 64 },
        }}
        gap={20}
        m={{ mb: 24 }}
      >
        <Title
          as="h2"
          size="medium"
          fontWeight="desktop.semibold"
          m={0}
          horizontalAlign="center"
          md={{ horizontalAlign: "left", maxWidth: "80%" }}
        >
          {data.title}
        </Title>
        {!isInactive && (
          <Button
            size="small"
            fontWeight="mobile.bold"
            onPress={handlePressButton}
            href={href}
            p={{ py: 12, px: 24 }}
            display="hidden"
            d={{ display: "block" }}
            whiteSpace="pre-wrap"
          >
            {data.action_text}
          </Button>
        )}
      </Flex>

      {isUseSwiper ? (
        <Flex width="100%" m={{ mx: "auto" }}>
          <Swiper
            spaceBetween={20}
            grabCursor
            breakpoints={{
              1024: { slidesPerView: 3 },
              768: { slidesPerView: 2, centeredSlides: false },
              340: {
                slidesPerView: 1,
                centeredSlides: true,
              },
            }}
          >
            {data?.cards?.map((card) => (
              <SwiperSlide key={card?.id}>
                <Flex
                  justify="center"
                  align="center"
                  md={{ flexDirection: "row", align: "stretch" }}
                  height="100%"
                >
                  {card && <RowCard key={card.id} {...props} card={card} />}
                </Flex>
              </SwiperSlide>
            ))}
          </Swiper>
        </Flex>
      ) : (
        <Flex
          md={{
            justify: "center",
            flexDirection: "row",
            align: "stretch",
            gap: 16,
          }}
          justify="center"
          flexDirection="column"
          align="center"
          gap={24}
          className="flex-wrap"
        >
          {data?.cards?.map(
            (card) => card && <RowCard key={card?.id} {...props} card={card} />,
          )}
        </Flex>
      )}

      {!isInactive && (
        <Flex
          align="center"
          justify="center"
          d={{ display: "hidden" }}
          m={{ mt: 24 }}
          md={{ m: { mt: 48 } }}
          display="flex"
        >
          <Button
            onPress={handlePressButton}
            href={href}
            size="medium"
            maxWidth="fit-content"
            maxHeight="fit-content"
            whiteSpace="pre-wrap"
            fontWeight="mobile.bold"
            p={{ py: 10, px: 44 }}
            lineHeight="button.mobile.medium"
          >
            {data.action_text}
          </Button>
        </Flex>
      )}
    </Flex>
  );
};
